import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { opacity } from '../utils/customPropStyles';
import Icon from './Icon';
import { SORT_DIRECTIONS } from '../constants';
import { computed } from 'mobx';
import { AccessibilityStore } from '../stores';
import { Theme } from '../models/Theme';

const SortToggleButton = styled<any, any>(
    'button',
    'sortToggleButton',
    'sortToggle'
)`
    ${propStyles};
    ${opacity};
    outline: none;
    & > img {
        position: absolute;
        top: -50%;
        left: -50%;
    }
`;

SortToggleButton.defaultProps = {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgColor: 'transparent',
    borderStyle: 'none',
    cursor: 'pointer',
    height: '1em',
    width: '1em',
    overflow: 'visible',
};

interface SortToggleProps {
    theme?: Theme;
    direction: 'ASC' | 'DESC' | undefined;
    disabled?: boolean;
    metricContext?: string;
    accessibilityStore?: AccessibilityStore;
    onClick(): void;
}

@inject('accessibilityStore')
@observer
class SortToggle extends Component<SortToggleProps> {
    @computed
    get fileName() {
        const { direction } = this.props;
        return direction === SORT_DIRECTIONS.ASC
            ? 'ColumnSortAscIcon'
            : direction === SORT_DIRECTIONS.DESC
            ? 'ColumnSortDescIcon'
            : 'ColumnSortOffIcon';
    }

    @computed
    get selected() {
        const { direction } = this.props;
        return (
            direction === SORT_DIRECTIONS.ASC ||
            direction === SORT_DIRECTIONS.DESC
        );
    }
    render() {
        const { theme, metricContext, accessibilityStore } = this.props;

        return (
            <SortToggleButton
                aria-label={accessibilityStore.buttonAccessibilityValue(
                    'SortToggleButton'
                )}
                data-selected={this.selected}
                opacity={this.selected ? '1' : '0.25'}
                data-metric-id={`sortToggle-${metricContext}`}
                {...theme.SortToggle}
                {...this.props}
            >
                <Icon fileName={this.fileName} />
            </SortToggleButton>
        );
    }
}

export default withTheme(SortToggle) as any;



// WEBPACK FOOTER //
// ./src/Components/SortToggle.tsx